import { loadModelDataWithWorker } from './loadModelWorkerApi';
import { parseModelTypes } from '../utils/modelType';
//variable to cache the models data globally druing the page load
let cachedModelsData = null;
//function to check and preload data with webworker
const preloadModelsData = async () => {
    if (cachedModelsData)
        return;
    try {
        cachedModelsData = await loadModelDataWithWorker();
    }
    catch (err) {
        console.error('Error loading models data from worker:', err);
        cachedModelsData = {};
        throw err;
    }
};
//function to fetch models list with filters applied and pagination
const fetchModels = (() => {
    let lastFilterKey = null;
    let lastFilteredModels = [];
    return async (filters, page = 1, limit = 9, fetchAll = false) => {
        try {
            const modelsData = getModelsData();
            const allModels = Object.values(modelsData);
            const filterKey = JSON.stringify({
                domain: Array.from(filters.domain).sort(),
                modelType: Array.from(filters.modelType).sort(),
                kit: Array.from(filters.kit).sort(),
                device: Array.from(filters.device).sort(),
                application: Array.from(filters.application).sort(),
            });
            if (filterKey !== lastFilterKey) {
                //recaculate the filterd modles if filter last filter key changes
                lastFilteredModels = allModels.filter((model) => {
                    var _a, _b, _c, _d;
                    const isDomain = filters.domain.size === 0 ||
                        !!((_a = model === null || model === void 0 ? void 0 : model.domain) === null || _a === void 0 ? void 0 : _a.some((domain) => filters.domain.has(domain)));
                    const modelTypes = parseModelTypes(model === null || model === void 0 ? void 0 : model.Type);
                    const isModelType = filters.modelType.size === 0 ||
                        modelTypes.some((modelType) => filters.modelType.has(modelType));
                    const isKit = filters.kit.size === 0 || !!((_b = model === null || model === void 0 ? void 0 : model.kit) === null || _b === void 0 ? void 0 : _b.some((kit) => filters.kit.has(kit)));
                    const isDevice = filters.device.size === 0 ||
                        !!((_c = model === null || model === void 0 ? void 0 : model.device) === null || _c === void 0 ? void 0 : _c.some((device) => filters.device.has(device)));
                    const isApp = filters.application.size === 0 ||
                        !!((_d = model === null || model === void 0 ? void 0 : model.application) === null || _d === void 0 ? void 0 : _d.some((app) => filters.application.has(app)));
                    return isDomain && isModelType && isKit && isDevice && isApp;
                });
                lastFilterKey = filterKey;
            }
            if (fetchAll) {
                return {
                    data: {
                        filtered_data: lastFilteredModels,
                        current_page: 1,
                        total_page: 1,
                    },
                };
            }
            const total = lastFilteredModels.length;
            const totalPages = Math.ceil(total / limit);
            const start = (page - 1) * limit;
            const paginatedData = lastFilteredModels.slice(start, start + limit);
            return {
                data: {
                    filtered_data: paginatedData,
                    current_page: page,
                    total_page: totalPages,
                },
            };
        }
        catch (error) {
            console.error('error fetching models', error);
            throw error;
        }
    };
})();
const fetchAllModels = () => {
    return Object.values(cachedModelsData || {});
};
//function to fetch detial of the model with given name
const fetchModelDetailsByName = async (name) => {
    try {
        const modelsData = getModelsData();
        return { data: { modelDetails: modelsData[`${name}`] } };
    }
    catch (error) {
        console.error('error fetching modles by name', error);
        throw error;
    }
};
//function to fetch filter values (domain, devices,kits, applications)
const fetchModelFilterFields = async () => {
    try {
        const modelsData = getModelsData();
        const allModels = Object.values(modelsData);
        const domainSet = new Set();
        const ModelTypeSet = new Set();
        const kitSet = new Set();
        const deviceSet = new Set();
        const applicationSet = new Set();
        for (const model of allModels) {
            if (Array.isArray(model === null || model === void 0 ? void 0 : model.domain)) {
                model.domain.forEach((d) => domainSet.add(d));
            }
            if (Array.isArray(model === null || model === void 0 ? void 0 : model.kit)) {
                model.kit.forEach((k) => kitSet.add(k));
            }
            if (Array.isArray(model === null || model === void 0 ? void 0 : model.device)) {
                model.device.forEach((d) => deviceSet.add(d));
            }
            if (Array.isArray(model === null || model === void 0 ? void 0 : model.application)) {
                model.application.forEach((a) => applicationSet.add(a));
            }
            parseModelTypes(model === null || model === void 0 ? void 0 : model.Type).forEach((modelType) => ModelTypeSet.add(modelType));
        }
        const filterFields = {
            domain: Array.from(domainSet).sort(),
            modelType: Array.from(ModelTypeSet).sort(),
            kit: Array.from(kitSet).sort(),
            device: Array.from(deviceSet).sort(),
            application: Array.from(applicationSet).sort(),
        };
        console.log('filter fields', filterFields);
        return { data: { filter_fields: filterFields } };
    }
    catch (error) {
        console.error('error fetching model filter fields', error);
        throw error;
    }
};
const getModelsData = () => {
    if (!cachedModelsData) {
        throw new Error('modle data not loaded  check preloadModelsData result');
    }
    return cachedModelsData;
};
export { fetchModels, fetchAllModels, fetchModelDetailsByName, fetchModelFilterFields, preloadModelsData, };
